{
  "en": {
    "helpTitle": "Help",
    "helpText": "This text is used to provide help to the user.",
    "langSelector": "Select Language",
    "test": "Hello World",
    "welcomeMsg":"Welcome to Trinkle WebComponents demo app",
    "param.blueness": "Blue",
    "marketingOffer":"Get 20% off your first purchase!",
    "parameters.step1.red-color":"Red",
    "apps.general.exit-without-saving": "You are about to exit with unsaved changes. Your progress will be lost. Do you want to continue?",
    "tooltip.view.perspective": "Toggle perspective view",
    "tooltip.view.fit": "Fit to screen",
    "tooltip.view.iso": "Isometric view",
    "tooltip.view.front": "Toggle front/back view",
    "tooltip.view.right": "Toggle right/left view",
    "tooltip.view.top": "Toggle top/bottom view",
    "tooltip.apps.home": "Back to App Suite",
    "tooltip.state.undo": "Undo",
    "tooltip.state.redo": "Redo",
    "tooltip.session.new": "New session",
    "tooltip.session.restore": "Restore session",
    "tooltip.session.save": "Save session",
    "base.app.title": "Demo",
    "Base.ErrorHeader": "Error",
    "Base.ErrorInfo.ErrorDescription.Generic": "An unexpected error occurred",
    "errorPanel.label.timestamp": "Timestamp",
    "errorPanel.label.sessionId": "Session ID",
    "errorPanel.label.error": "Error",
    "errorPanel.label.serverCode": "Server Code",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copy to Clipboard",
    "Base.ErrorPanel.Button.Undo": "Undo",
    "paramateError.serviceInterrupted.title": "Service Interrupted",
    "paramateError.serviceInterrupted.message": "A service was interrupted due to a loss of internet connection. Please check your connection and try again.",
    "paramateError.unsupportedFileFormat.title": "Unsupported File Format",
    "paramateError.unsupportedFileFormat.message": "The uploaded file format is not supported. Please upload a file in a supported format.",
    "paramateError.fileTooComplex.title": "File Too Complex to Process",
    "paramateError.fileTooComplex.message": "The uploaded file seems to be too complex to process. STEP/3MF files can expand significantly upon conversion and may exceed the supported limit. Please suppress any unwanted geometry in your CAD software, export the file as an STL, and upload it again. The recommended file size is under 10 MB.",
    "paramateError.sessionFileNotRecognized.title": "Session File Not Recognized",
    "paramateError.sessionFileNotRecognized.message": "The provided file could not be restored as a session. Please check your file, it may be incompatible.",
    "paramateError.saveOperationTimeout.title": "Save Operation Timeout",
    "paramateError.saveOperationTimeout.message": "The file could not be saved. The operation exceeded the expected time limit. If you have STEP export enabled, switching to STL may help. Reducing the export scope by selecting only the models you need may also speed things up. Please try again.",
    "paramateError.operationTimeout.title": "Operation Timeout",
    "paramateError.operationTimeout.message": "The current operation could not be completed. The process exceeded the expected time limit.",
    "paramateError.unexpectedError.title": "Unexpected Error",
    "paramateError.unexpectedError.message": "An unexpected error occurred on the server. Please try again later.",
    "paramateError.meshTransferFailed.title": "Mesh Transfer Failed",
    "paramateError.meshTransferFailed.message": "The mesh could not be transferred. The file may be too large, malformed, or incompatible with the target application.",
    "paramateError.grabcadTransferFailed.title": "Transfer Failed",
    "paramateError.grabcadTransferFailed.message": "The transfer to GrabCAD could not be completed. Please save your session and try again later. Alternatively, you can export the file and upload it to GrabCAD Print Pro manually.",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Help",
    "tooltip.feature.settings": "Options",
    "tooltip.feature.toggle-workpiece-view": "Show/Hide Workpiece",
    "tooltip.feature.transfer-mesh": "Transfer Mesh",
    "notifications.demo.title": "Notification Examples",
    "notifications.demo.info.button": "Show Info Notification",
    "notifications.demo.success.button": "Show Success Notification",
    "notifications.demo.warning.button": "Show Warning Notification",
    "notifications.demo.error.button": "Show Error Notification",
    "notifications.demo.trigger-error.button": "Trigger Error",
    "notifications.demo.persistent.button": "Show Persistent Notification",
    "notifications.demo.timeout.button": "Custom Timeout (10s)",
    "notifications.demo.clear.button": "Clear All Notifications",
    "notifications.demo.info.message": "This is an info notification",
    "notifications.demo.success.message": "This is a success notification",
    "notifications.demo.warning.message": "This is a warning notification",
    "notifications.demo.error.message": "This is an error notification",
    "notifications.demo.persistent.message": "This is a persistent notification",
    "notifications.demo.timeout.message": "This is a custom timeout notification",
    "notifications.mesh.transfer.save.success": "Mesh saved successfully",
    "notifications.mesh.transfer.save.error": "Mesh save failed",
    "notifications.mesh.autoload.detected": "Detected mesh from {0}: {1}",
    "translations.demo": "This text will be automatically translated.",
    "footer.trinckle-label": "trinckle design automation application | Powered by paramate",
    "footer.version.app": "app v{0}",
    "footer.version.grabcad": "GC",
    "footer.version.env": "({0})",
    "footer.version.components": "ASC v{0}",
    "footer.version.script": "script v{0}",
    "footer.version.trcad": "trCAD v{0}",
    "fileIO.import.subheading": "Import {0}",
    "fileIO.import.subject": "Workpiece",
    "fileIO.import.hint": "Recommended format: .STL",
    "fileIO.import.sampleButton": "Try sample data",
    "fileIO.import.sampleTooltip": "Try the app with sample data - no file needed",
    "fileIO.import.hintLinkDefault": "Click here",
    "fileIO.export.heading": "Export",
    "fileIO.export.saveButton": "Save file",
    "fileIO.export.saveTooltip": "Save the selected models to your computer.",
    "fileIO.export.transferButton": "Send to other apps…",
    "fileIO.export.transferTooltip": "Send the selected parts to another app in Additive App Suite for the next step.",
    "fileIO.export.scopeHeading": "Export scope",
    "fileIO.export.scopeDescription": "Choose what to include in your export.",
    "fileIO.export.settingsHeading": "Save file settings",
    "fileIO.export.nameLabel": "Name",
    "fileIO.export.nameTooltip": "Choose the name for the exported package.",
    "fileIO.export.formatLabel": "Model format",
    "fileIO.export.formatTooltip": "Choose the file format for local saving.",
    "fileIO.export.ok": "OK",
    "fileIO.export.scope.outputParts": "Output parts",
    "fileIO.export.scope.workpieces": "Workpieces",
    "fileIO.export.scope.standardComponents": "Standard Components",
    "fileIO.export.auxHeading": "Auxiliary files",
    "fileIO.export.auxStep": "STEP",
    "fileIO.export.previewHeading": "Design preview",
    "fileIO.export.previewDescription": "Preview your final, printable part before exporting.",
    "fileIO.export.previewShow": "Show export preview",
    "fileIO.export.previewHide": "Hide export preview",
    "fileIO.download.pending": "Downloading...",
    "fileIO.download.disabledTooltip": "This app needs a license for downloads.",
    "notifications.configure.timeout": "This process is taking a while. Would you like to cancel and adjust?",
    "notifications.configure.timeout.cancel": "Cancel",
    "notifications.configure.timeout.dismiss": "Dismiss",
    "notifications.import.timeout": "This import is taking a while. Would you like to cancel it?",
    "fileIO.upload.chooseFile": "Choose File",
    "fileIO.upload.dropHere": "or drop file here",
    "fileIO.upload.chooseImage": "Choose Image",
    "fileIO.upload.dropImageHere": "or drop image here",
    "fileIO.upload.accepts": "Accepts: {0}",
    "fileIO.upload.chooseNewFile": "Choose new file",
    "fileIO.upload.remove": "Remove",
    "fileIO.upload.replaceWarning": "Replacing this file cannot be undone. Continue?",
    "fileIO.upload.replaceConfirm": "Replace",
    "fileIO.upload.replaceCancel": "Cancel",
    "fileIO.upload.fileUploaded": "File uploaded",
    "fileIO.upload.filesUploadedCount": "{0} files uploaded",
    "fileIO.upload.importing": "Importing file",
    "fileIO.upload.importingCount": "Importing file {0} of {1}",
    "paramWarning.notFound": "Parameter '{0}' not found in configurator",
    "tooltip.project.rename": "Rename",
    "tooltip.project.restore": "Restore saved state",
    "tooltip.project.save": "Save",
    "tooltip.project.delete": "Delete",
    "tooltip.project.open": "Open",
    "tooltip.state.undoWarn": "Undoing will clear redo stack!",
    "modals.export.progress.heading": "Exporting…",
    "modals.export.progress.cancelButton": "Cancel export",
    "modals.export.progress.cancelling": "Cancelling…",
    "modals.export.progress.finishing": "Finishing up…",
    "modals.export.progress.failedHeading": "Export failed",
    "modals.project.save.description": "Give your project a name. It will also be used as the filename when downloading.",
    "modals.grabcad.success.cancel": "Cancel",
    "modals.grabcad.success.close": "Close",
    "modals.grabcad.success.saveAndClose": "Save and close",
    "notifications.project.new": "New project created",
    "notifications.project.loaded": "Loaded project: {0}",
    "notifications.project.saved": "Project saved: {0}",
    "notifications.project.savedIncomplete": "Project saved: {0}, but some app state could not be captured",
    "notifications.project.loadFailed": "Failed to load project file",
    "notifications.project.wrongApp": "This .asproject file is meant for the {0} app.",
    "notifications.error.aborted": "Operation aborted. If you didn't cancel, your connection may be unstable.",
    "notifications.api.badResponse": "Something went wrong talking to the server. Please try again.",
    "notifications.auth.signOut.error": "Sign out failed. Please try again.",
    "notifications.auth.terms.error": "Could not save your acceptance. Please try again.",
    "notifications.export.noParts": "No parts to export. Check that your export scope is configured correctly.",
    "notifications.import.failed": "File import failed: {0}",
    "notifications.import.rejectedType.one": "{0} is not an accepted file type.",
    "notifications.import.rejectedType.oneWithAccepts": "{0} is not an accepted file type. Accepts: {1}.",
    "notifications.import.rejectedType.many": "These files are not accepted types: {0}.",
    "notifications.import.rejectedType.manyWithAccepts": "These files are not accepted types: {0}. Accepts: {1}.",
    "notifications.mesh.download.error": "Error downloading mesh: {0}",
    "notifications.mesh.transfer.notReady": "Cannot transfer mesh: the configurator is not ready yet. Please wait a moment and try again.",
    "notifications.mesh.transfer.no-apps.error": "Cannot transfer mesh: no apps are available for transfer. The app configuration may not be loaded yet.",
    "notifications.mesh.transfer.failed": "Error during mesh transfer: {0}",
    "notifications.mesh.rx.loadFailed": "Could not load the transferred mesh: {0}",
    "notifications.mesh.rx.skip": "Skip transfer",
    "notifications.mesh.rx.saveAs": "Save transfer as file",
    "apps.general.may-lose-changes": "You have unsaved changes.",
    "apps.general.save-before-leaving": "Save your work before leaving?",
    "apps.general.saved-leave-when-ready": "Your changes have been saved. You can leave when you are ready.",
    "apps.general.finishing-up": "Finishing up, please wait...",
    "modals.unsaved.cancel": "Cancel",
    "modals.unsaved.save": "Save",
    "modals.unsaved.proceed.close": "Close",
    "modals.unsaved.proceed.home": "Exit",
    "modals.unsaved.proceed.new": "Start new",
    "modals.unsaved.proceed.transfer": "Transfer",
    "modals.unsaved.discard.close": "Close without saving",
    "modals.unsaved.discard.home": "Exit without saving",
    "modals.unsaved.discard.new": "Start new without saving",
    "modals.unsaved.discard.transfer": "Transfer without saving",
    "modals.unsaved.saveAnd.close": "Save and Close",
    "modals.unsaved.saveAnd.home": "Save and Exit",
    "modals.unsaved.saveAnd.new": "Save and Start new",
    "modals.unsaved.saveAnd.transfer": "Save and Transfer",
    "modals.project.save.title": "Save project",
    "modals.project.save.name-label": "Project name",
    "modals.project.save.cancel": "Cancel",
    "modals.project.save.confirm": "Save",
    "apps.general.restore-session.title": "Unsaved Session Found",
    "apps.general.restore-session.body": "You have an unsaved session from a previous visit. Would you like to restore it or start fresh?",
    "modals.restore-session.start-new": "Start New",
    "modals.restore-session.restore": "Restore",
    "apps.general.expired-session.title": "Session Expired",
    "apps.general.expired-session.body": "Your session has expired. Start a new session to continue.",
    "modals.expired-session.start-new": "Start New Session",
    "apps.general.accept-terms.title": "Terms and Conditions",
    "apps.general.accept-terms.body": "Please accept the new terms and conditions to continue.",
    "apps.general.accept-terms.link": "General Terms and Conditions",
    "apps.general.accept-terms.checkbox": "I have read and accept the terms above.",
    "apps.general.accept-terms.cancel": "Cancel",
    "apps.general.accept-terms.continue": "Continue",
    "modals.paramate-error.ok": "OK",
    "modals.paramate-error.session-id": "Session ID: {0}",
    "modals.clickthru.open-new-tab": "Open in new tab",
    "modals.clickthru.close": "Close",
    "modals.mobile-warning.title": "Mobile Detected",
    "modals.mobile-warning.body": "Thank you for your interest in the Additive App-Suite! This app is optimized for desktop use, please return on a suitable device.",
    "modals.mobile-warning.back": "Back to Storefront",
    "modals.transfer.ready.title": "Mesh ready for transfer",
    "modals.transfer.ready.description": "Your data may be lost! Please save your work before continuing.",
    "modals.transfer.ready.action-label": "Transfer to:",
    "modals.transfer.ready.open-in-new-tab": "Open in new tab",
    "header.help.tooltip": "Need help? Click here for a tutorial.",
    "license.label": "License:",
    "license.none": "No license",
    "tooltip.feature.info": "Info",
    "userGreeting": "Hello {0}",
    "userGreeting.loading": "Hello",
    "signOutLink": "Sign Out",
    "manageAccountLink": "Manage Account",
    "tooltip.userOptions": "User options",
    "license.expired": "{0} (Expired)",
    "license.trialDaysLeft": "{0} – {1} days left",
    "license.trialDayLeft": "{0} – {1} day left",
    "license.type.trial": "Trial",
    "license.type.pro": "Pro",
    "license.type.enterprise": "Enterprise",
    "user.unnamed": "User",
    "session.untitled": "Untitled",
    "modals.error.prefix": "Error: {0}",
    "modals.mesh.history.title": "Mesh History",
    "modals.mesh.history.empty": "No mesh history found",
    "modals.mesh.history.colName": "Name",
    "modals.mesh.history.colLastSave": "Last Save",
    "modals.mesh.history.colOrigin": "Origin",
    "modals.mesh.history.clearAll": "Clear All History",
    "modals.mesh.history.close": "Close",
    "modals.mesh.restore.title": "Restore Mesh",
    "modals.mesh.restore.body": "A previously saved mesh was found that can be loaded:",
    "modals.mesh.restore.name": "Name:",
    "modals.mesh.restore.fromApp": "From app:",
    "modals.mesh.restore.lastSaved": "Last saved:",
    "modals.mesh.restore.question": "Would you like to load this mesh?",
    "modals.mesh.restore.load": "Load Mesh",
    "modals.mesh.restore.skip": "Skip",
    "modals.grabcad.success.transferred": "Your design was transferred to GrabCAD Print and was placed on the build tray.",
    "modals.grabcad.success.prepare": "You can start the print preparation now after closing this app.",
    "modals.grabcad.success.saveFirst": "Please don't forget to save your project beforehand.",
    "modals.grabcad.success.saving": "Saving…",
    "grabcad.transfer.button": "Transfer to GrabCAD Print",
    "grabcad.transfer.tooltip": "Transfer your design to GrabCAD Print. Models will be placed on the build tray, where you can prepare them for printing. Note: Depending on your selection, you can switch between the assembly and individual parts in the GrabCAD Print model tree.",
    "grabcad.transfer.sending": "Sending...",
    "fileIO.import.trySample": "Try sample data",
    "modals.clickthru.noUrl": "No URL provided for clickthrough demo"
  },
  "de": {
    "helpTitle": "Hilfe",
    "helpText": "Dieser Text wird verwendet, um Hilfe für den Benutzer bereitzustellen.",
    "langSelector": "Sprache auswählen",
    "test": "Hallo Welt",
    "welcomeMsg":"Willkommen bei der Trinkle WebComponents Demo-App.",
    "param.blueness": "Blau",
    "marketingOffer":"Erhalten Sie 20% Rabatt auf Ihre erste Bestellung!",
    "apps.general.exit-without-saving": "Sie sind dabei, mit ungespeicherten Änderungen zu beenden. Ihr Fortschritt geht verloren. Möchten Sie fortfahren?",
    "tooltip.view.perspective": "Perspektivische Ansicht umschalten.",
    "tooltip.view.fit": "An Bildschirm anpassen.",
    "tooltip.view.iso": "Isometrische Ansicht.",
    "tooltip.view.front": "Vorder-/Rückansicht umschalten.",
    "tooltip.view.right": "Rechts-/Linksansicht umschalten.",
    "tooltip.view.top": "Oben-/Untenansicht umschalten.",
    "tooltip.apps.home": "Zurück zur App Suite.",
    "tooltip.state.undo": "Rückgängig.",
    "tooltip.state.redo": "Wiederholen.",
    "tooltip.session.new": "Neue Sitzung.",
    "tooltip.session.restore": "Sitzung wiederherstellen.",
    "tooltip.session.save": "Sitzung speichern.",
    "base.app.title": "Demo (DE)",
    "Base.ErrorHeader": "Fehler",
    "Base.ErrorInfo.ErrorDescription.Generic": "Ein unerwarteter Fehler ist aufgetreten",
    "errorPanel.label.timestamp": "Zeitstempel",
    "errorPanel.label.sessionId": "Sitzungs-ID",
    "errorPanel.label.error": "Fehler",
    "errorPanel.label.serverCode": "Server-Code",
    "Base.ErrorPanel.Button.CopyToClipboard": "In die Zwischenablage kopieren",
    "Base.ErrorPanel.Button.Undo": "Rückgängig",
    "Base.AppTitle": "App Suite",
    "tooltip.feature.help": "Hilfe",
    "tooltip.feature.settings": "Optionen",
    "tooltip.feature.toggle-workpiece-view": "Werkstück anzeigen/ausblenden",
    "tooltip.feature.transfer-mesh": "Netz übertragen",
    "notifications.demo.title": "Benachrichtigung Beispiele",
    "notifications.demo.info.button": "Info Benachrichtigung anzeigen",
    "notifications.demo.success.button": "Erfolg Benachrichtigung anzeigen",
    "notifications.demo.warning.button": "Warnung Benachrichtigung anzeigen",
    "notifications.demo.error.button": "Fehler Benachrichtigung anzeigen",
    "notifications.demo.trigger-error.button": "Fehler auslösen",
    "notifications.demo.persistent.button": "Langfristige Benachrichtigung anzeigen",
    "notifications.demo.timeout.button": "Timeout (10s)",
    "notifications.demo.clear.button": "Alle Benachrichtigungen löschen",
    "notifications.demo.info.message": "Dies ist eine Info-Benachrichtigung",
    "notifications.demo.success.message": "Dies ist eine Erfolg-Benachrichtigung",
    "notifications.demo.warning.message": "Dies ist eine Warnung-Benachrichtigung",
    "notifications.demo.error.message": "Dies ist eine Fehler-Benachrichtigung",
    "notifications.demo.persistent.message": "Dies ist eine Langfristige-Benachrichtigung",
    "notifications.demo.timeout.message": "Dies ist eine Timeout-Benachrichtigung",
    "notifications.mesh.transfer.save.success": "Netz erfolgreich gespeichert",
    "notifications.mesh.transfer.save.error": "Netz speichern fehlgeschlagen",
    "notifications.mesh.autoload.detected": "Netz von {0} erkannt: {1}",
    "translations.demo": "Dieser Text wird automatisch übersetzt.",
    "widgets.title": "Widgets",
    "footer.version.app": "app v{0}",
    "footer.version.grabcad": "GC",
    "footer.version.env": "({0})",
    "footer.version.components": "ASC v{0}",
    "footer.version.script": "script v{0}",
    "footer.version.trcad": "trCAD v{0}",
    "fileIO.import.subheading": "{0} importieren",
    "fileIO.import.subject": "Werkstück",
    "fileIO.import.hint": "Empfohlenes Format: .STL",
    "fileIO.import.sampleButton": "Beispieldaten testen",
    "fileIO.import.sampleTooltip": "Die App mit Beispieldaten testen – keine Datei nötig",
    "fileIO.import.hintLinkDefault": "Hier klicken",
    "fileIO.export.heading": "Export",
    "fileIO.export.saveButton": "Datei speichern",
    "fileIO.export.saveTooltip": "Die ausgewählten Modelle auf Ihrem Computer speichern.",
    "fileIO.export.transferButton": "An andere Apps senden…",
    "fileIO.export.transferTooltip": "Die ausgewählten Teile für den nächsten Schritt an eine andere App in Additive App Suite senden.",
    "fileIO.export.scopeHeading": "Exportumfang",
    "fileIO.export.scopeDescription": "Wählen Sie aus, was in Ihren Export aufgenommen werden soll.",
    "fileIO.export.settingsHeading": "Dateispeicher-Einstellungen",
    "fileIO.export.nameLabel": "Name",
    "fileIO.export.nameTooltip": "Wählen Sie den Namen für das exportierte Paket.",
    "fileIO.export.formatLabel": "Modellformat",
    "fileIO.export.formatTooltip": "Wählen Sie das Dateiformat für die lokale Speicherung.",
    "fileIO.export.ok": "OK",
    "fileIO.export.scope.outputParts": "Ausgabeteile",
    "fileIO.export.scope.workpieces": "Werkstücke",
    "fileIO.export.scope.standardComponents": "Standardkomponenten",
    "fileIO.export.auxHeading": "Zusatzdateien",
    "fileIO.export.auxStep": "STEP",
    "fileIO.export.previewHeading": "Designvorschau",
    "fileIO.export.previewDescription": "Ihr fertiges, druckbares Teil vor dem Export in der Vorschau ansehen.",
    "fileIO.export.previewShow": "Exportvorschau anzeigen",
    "fileIO.export.previewHide": "Exportvorschau ausblenden",
    "fileIO.download.pending": "Wird heruntergeladen…",
    "fileIO.download.disabledTooltip": "Diese App benötigt eine Lizenz für Downloads.",
    "notifications.configure.timeout": "Dieser Vorgang dauert länger als erwartet. Möchten Sie abbrechen und Anpassungen vornehmen?",
    "notifications.configure.timeout.cancel": "Abbrechen",
    "notifications.configure.timeout.dismiss": "Schließen",
    "notifications.import.timeout": "Der Import dauert länger als erwartet. Möchten Sie ihn abbrechen?",
    "fileIO.upload.chooseFile": "Datei auswählen",
    "fileIO.upload.dropHere": "oder Datei hierher ziehen",
    "fileIO.upload.chooseImage": "Bild auswählen",
    "fileIO.upload.dropImageHere": "oder Bild hierher ziehen",
    "fileIO.upload.accepts": "Akzeptiert: {0}",
    "fileIO.upload.chooseNewFile": "Neue Datei wählen",
    "fileIO.upload.remove": "Entfernen",
    "fileIO.upload.replaceWarning": "Das Ersetzen dieser Datei kann nicht rückgängig gemacht werden. Fortfahren?",
    "fileIO.upload.replaceConfirm": "Ersetzen",
    "fileIO.upload.replaceCancel": "Abbrechen",
    "fileIO.upload.fileUploaded": "Datei hochgeladen",
    "fileIO.upload.filesUploadedCount": "{0} Dateien hochgeladen",
    "fileIO.upload.importing": "Datei wird importiert",
    "fileIO.upload.importingCount": "Datei {0} von {1} wird importiert",
    "paramWarning.notFound": "Parameter „{0}“ wurde im Konfigurator nicht gefunden",
    "tooltip.project.rename": "Umbenennen",
    "tooltip.project.restore": "Gespeicherten Zustand wiederherstellen",
    "tooltip.project.save": "Speichern",
    "tooltip.project.delete": "Löschen",
    "tooltip.project.open": "Öffnen",
    "tooltip.state.undoWarn": "Rückgängig machen löscht den Wiederholen-Verlauf!",
    "modals.export.progress.heading": "Wird exportiert…",
    "modals.export.progress.cancelButton": "Export abbrechen",
    "modals.export.progress.cancelling": "Wird abgebrochen…",
    "modals.export.progress.finishing": "Wird abgeschlossen…",
    "modals.export.progress.failedHeading": "Export fehlgeschlagen",
    "modals.project.save.description": "Geben Sie Ihrem Projekt einen Namen. Er wird auch als Dateiname beim Herunterladen verwendet.",
    "modals.grabcad.success.cancel": "Abbrechen",
    "modals.grabcad.success.close": "Schließen",
    "modals.grabcad.success.saveAndClose": "Speichern und schließen",
    "notifications.project.new": "Neues Projekt erstellt",
    "notifications.project.loaded": "Projekt geladen: {0}",
    "notifications.project.saved": "Projekt gespeichert: {0}",
    "notifications.project.savedIncomplete": "Projekt gespeichert: {0}, aber ein Teil des App-Zustands konnte nicht erfasst werden",
    "notifications.project.loadFailed": "Projektdatei konnte nicht geladen werden",
    "notifications.project.wrongApp": "Diese .asproject-Datei gehört zur App {0}.",
    "notifications.error.aborted": "Vorgang abgebrochen. Falls Sie nicht abgebrochen haben, ist Ihre Verbindung möglicherweise instabil.",
    "notifications.api.badResponse": "Bei der Kommunikation mit dem Server ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "notifications.auth.signOut.error": "Abmelden fehlgeschlagen. Bitte versuchen Sie es erneut.",
    "notifications.auth.terms.error": "Ihre Zustimmung konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.",
    "notifications.export.noParts": "Keine Teile zum Exportieren. Prüfen Sie, ob der Exportbereich richtig konfiguriert ist.",
    "notifications.import.failed": "Dateiimport fehlgeschlagen: {0}",
    "notifications.import.rejectedType.one": "{0} ist kein zulässiger Dateityp.",
    "notifications.import.rejectedType.oneWithAccepts": "{0} ist kein zulässiger Dateityp. Zulässig: {1}.",
    "notifications.import.rejectedType.many": "Diese Dateien haben keinen zulässigen Typ: {0}.",
    "notifications.import.rejectedType.manyWithAccepts": "Diese Dateien haben keinen zulässigen Typ: {0}. Zulässig: {1}.",
    "notifications.mesh.download.error": "Fehler beim Herunterladen des Netzes: {0}",
    "notifications.mesh.transfer.notReady": "Netz kann nicht übertragen werden: Der Konfigurator ist noch nicht bereit. Bitte warten Sie einen Moment und versuchen Sie es erneut.",
    "notifications.mesh.transfer.no-apps.error": "Netz kann nicht übertragen werden: Es sind keine Apps verfügbar. Die App-Konfiguration ist möglicherweise noch nicht geladen.",
    "notifications.mesh.transfer.failed": "Fehler bei der Netzübertragung: {0}",
    "notifications.mesh.rx.loadFailed": "Das übertragene Netz konnte nicht geladen werden: {0}",
    "notifications.mesh.rx.skip": "Übertragung überspringen",
    "notifications.mesh.rx.saveAs": "Übertragung als Datei speichern",
    "apps.general.may-lose-changes": "Sie haben nicht gespeicherte Änderungen.",
    "apps.general.save-before-leaving": "Arbeit vor dem Verlassen speichern?",
    "apps.general.saved-leave-when-ready": "Ihre Änderungen wurden gespeichert. Sie können die Seite verlassen, wenn Sie so weit sind.",
    "apps.general.finishing-up": "Wird abgeschlossen, bitte warten...",
    "modals.unsaved.cancel": "Abbrechen",
    "modals.unsaved.save": "Speichern",
    "modals.unsaved.proceed.close": "Schließen",
    "modals.unsaved.proceed.home": "Beenden",
    "modals.unsaved.proceed.new": "Neu beginnen",
    "modals.unsaved.proceed.transfer": "Übertragen",
    "modals.unsaved.discard.close": "Ohne Speichern schließen",
    "modals.unsaved.discard.home": "Ohne Speichern beenden",
    "modals.unsaved.discard.new": "Ohne Speichern neu beginnen",
    "modals.unsaved.discard.transfer": "Ohne Speichern übertragen",
    "modals.unsaved.saveAnd.close": "Speichern und schließen",
    "modals.unsaved.saveAnd.home": "Speichern und beenden",
    "modals.unsaved.saveAnd.new": "Speichern und neu beginnen",
    "modals.unsaved.saveAnd.transfer": "Speichern und übertragen",
    "modals.project.save.title": "Projekt speichern",
    "modals.project.save.name-label": "Projektname",
    "modals.project.save.cancel": "Abbrechen",
    "modals.project.save.confirm": "Speichern",
    "apps.general.restore-session.title": "Nicht gespeicherte Sitzung gefunden",
    "apps.general.restore-session.body": "Aus einem früheren Besuch liegt eine nicht gespeicherte Sitzung vor. Möchten Sie sie wiederherstellen oder neu beginnen?",
    "modals.restore-session.start-new": "Neu beginnen",
    "modals.restore-session.restore": "Wiederherstellen",
    "apps.general.expired-session.title": "Sitzung abgelaufen",
    "apps.general.expired-session.body": "Ihre Sitzung ist abgelaufen. Starten Sie eine neue Sitzung, um fortzufahren.",
    "modals.expired-session.start-new": "Neue Sitzung starten",
    "apps.general.accept-terms.title": "Allgemeine Geschäftsbedingungen",
    "apps.general.accept-terms.body": "Bitte akzeptieren Sie die neuen Geschäftsbedingungen, um fortzufahren.",
    "apps.general.accept-terms.link": "Allgemeine Geschäftsbedingungen",
    "apps.general.accept-terms.checkbox": "Ich habe die oben stehenden Bedingungen gelesen und akzeptiere sie.",
    "apps.general.accept-terms.cancel": "Abbrechen",
    "apps.general.accept-terms.continue": "Weiter",
    "modals.paramate-error.ok": "OK",
    "modals.paramate-error.session-id": "Sitzungs-ID: {0}",
    "modals.clickthru.open-new-tab": "In neuem Tab öffnen",
    "modals.clickthru.close": "Schließen",
    "modals.mobile-warning.title": "Mobilgerät erkannt",
    "modals.mobile-warning.body": "Vielen Dank für Ihr Interesse an der Additive App-Suite! Diese App ist für den Desktop ausgelegt. Bitte kommen Sie auf einem geeigneten Gerät wieder.",
    "modals.mobile-warning.back": "Zurück zum Shop",
    "modals.transfer.ready.title": "Netz bereit zur Übertragung",
    "modals.transfer.ready.description": "Ihre Daten könnten verloren gehen. Bitte speichern Sie Ihre Arbeit, bevor Sie fortfahren.",
    "modals.transfer.ready.action-label": "Übertragen an:",
    "modals.transfer.ready.open-in-new-tab": "In neuem Tab öffnen",
    "header.help.tooltip": "Brauchen Sie Hilfe? Hier geht es zum Tutorial.",
    "license.label": "Lizenz:",
    "license.none": "Keine Lizenz",
    "tooltip.feature.info": "Info",
    "footer.trinckle-label": "trinckle Anwendung für Designautomatisierung | Powered by paramate",
    "paramateError.serviceInterrupted.title": "Dienst unterbrochen",
    "paramateError.serviceInterrupted.message": "Ein Dienst wurde durch eine unterbrochene Internetverbindung gestoppt. Bitte prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    "paramateError.unsupportedFileFormat.title": "Nicht unterstütztes Dateiformat",
    "paramateError.unsupportedFileFormat.message": "Das hochgeladene Dateiformat wird nicht unterstützt. Bitte laden Sie eine Datei in einem unterstützten Format hoch.",
    "paramateError.fileTooComplex.title": "Datei zu komplex zur Verarbeitung",
    "paramateError.fileTooComplex.message": "Die hochgeladene Datei ist offenbar zu komplex. STEP- und 3MF-Dateien wachsen beim Konvertieren stark an und können das Limit überschreiten. Bitte unterdrücken Sie nicht benötigte Geometrie in Ihrer CAD-Software, exportieren Sie die Datei als STL und laden Sie sie erneut hoch. Empfohlen sind unter 10 MB.",
    "paramateError.saveOperationTimeout.title": "Zeitüberschreitung beim Speichern",
    "paramateError.saveOperationTimeout.message": "Die Datei konnte nicht gespeichert werden. Der Vorgang hat die erwartete Zeit überschritten. Wenn der STEP-Export aktiv ist, kann ein Wechsel zu STL helfen. Auch ein kleinerer Exportumfang beschleunigt den Vorgang. Bitte versuchen Sie es erneut.",
    "paramateError.operationTimeout.title": "Zeitüberschreitung",
    "paramateError.operationTimeout.message": "Der laufende Vorgang konnte nicht abgeschlossen werden. Er hat die erwartete Zeit überschritten.",
    "paramateError.unexpectedError.title": "Unerwarteter Fehler",
    "paramateError.unexpectedError.message": "Auf dem Server ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
    "paramateError.sessionFileNotRecognized.title": "Sitzungsdatei nicht erkannt",
    "paramateError.sessionFileNotRecognized.message": "Die angegebene Datei konnte nicht als Sitzung wiederhergestellt werden. Bitte prüfen Sie die Datei, sie ist möglicherweise nicht kompatibel.",
    "paramateError.grabcadTransferFailed.title": "Übertragung fehlgeschlagen",
    "paramateError.grabcadTransferFailed.message": "Die Übertragung an GrabCAD konnte nicht abgeschlossen werden. Bitte speichern Sie Ihre Sitzung und versuchen Sie es später erneut. Alternativ können Sie die Datei exportieren und selbst in GrabCAD Print Pro hochladen.",
    "paramateError.meshTransferFailed.title": "Netzübertragung fehlgeschlagen",
    "paramateError.meshTransferFailed.message": "Das Netz konnte nicht übertragen werden. Die Datei ist möglicherweise zu groß, fehlerhaft oder mit der Zielanwendung nicht kompatibel.",
    "userGreeting": "Hallo {0}",
    "userGreeting.loading": "Hallo",
    "signOutLink": "Abmelden",
    "manageAccountLink": "Konto verwalten",
    "tooltip.userOptions": "Benutzeroptionen",
    "license.expired": "{0} (abgelaufen)",
    "license.trialDaysLeft": "{0} – noch {1} Tage",
    "license.trialDayLeft": "{0} – noch {1} Tag",
    "license.type.trial": "Test",
    "license.type.pro": "Pro",
    "license.type.enterprise": "Enterprise",
    "user.unnamed": "Benutzer",
    "session.untitled": "Unbenannt",
    "modals.error.prefix": "Fehler: {0}",
    "modals.mesh.history.title": "Netzverlauf",
    "modals.mesh.history.empty": "Kein Netzverlauf gefunden",
    "modals.mesh.history.colName": "Name",
    "modals.mesh.history.colLastSave": "Zuletzt gespeichert",
    "modals.mesh.history.colOrigin": "Herkunft",
    "modals.mesh.history.clearAll": "Gesamten Verlauf löschen",
    "modals.mesh.history.close": "Schließen",
    "modals.mesh.restore.title": "Netz wiederherstellen",
    "modals.mesh.restore.body": "Es wurde ein zuvor gespeichertes Netz gefunden, das geladen werden kann:",
    "modals.mesh.restore.name": "Name:",
    "modals.mesh.restore.fromApp": "Aus App:",
    "modals.mesh.restore.lastSaved": "Zuletzt gespeichert:",
    "modals.mesh.restore.question": "Möchten Sie dieses Netz laden?",
    "modals.mesh.restore.load": "Netz laden",
    "modals.mesh.restore.skip": "Überspringen",
    "modals.grabcad.success.transferred": "Ihr Entwurf wurde an GrabCAD Print übertragen und auf dem Bauraum platziert.",
    "modals.grabcad.success.prepare": "Nach dem Schließen dieser App können Sie mit der Druckvorbereitung beginnen.",
    "modals.grabcad.success.saveFirst": "Bitte denken Sie daran, Ihr Projekt vorher zu speichern.",
    "modals.grabcad.success.saving": "Wird gespeichert…",
    "grabcad.transfer.button": "An GrabCAD Print übertragen",
    "grabcad.transfer.tooltip": "Übertragen Sie Ihren Entwurf an GrabCAD Print. Die Modelle werden auf dem Bauraum platziert, wo Sie sie für den Druck vorbereiten können. Hinweis: Je nach Auswahl können Sie im Modellbaum von GrabCAD Print zwischen der Baugruppe und den Einzelteilen wechseln.",
    "grabcad.transfer.sending": "Wird gesendet...",
    "fileIO.import.trySample": "Beispieldaten ausprobieren",
    "modals.clickthru.noUrl": "Keine URL für die Klickdemo angegeben"
  },
  "es": {
    "helpTitle": "Ayuda",
    "helpText": "Este texto se utiliza para proporcionar ayuda al usuario.",
    "langSelector": "Seleccionar idioma",
    "test": "Hola Mundo",
    "welcomeMsg":"Bienvenido a la aplicación de demostración de Trinkle WebComponents.",
    "param.blueness": "Azul",
    "marketingOffer":"Obtenga un descuento del 20% en su primera compra!",
    "apps.general.exit-without-saving": "Estás a punto de salir con cambios sin guardar. Se perderá tu progreso. ¿Quieres continuar?",
    "tooltip.view.perspective": "Alternar vista en perspectiva.",
    "tooltip.view.fit": "Ajustar a la pantalla.",
    "tooltip.view.iso": "Vista isométrica.",
    "tooltip.view.front": "Alternar vista frontal/trasera.",
    "tooltip.view.right": "Alternar vista derecha/izquierda.",
    "tooltip.view.top": "Alternar vista superior/inferior.",
    "tooltip.apps.home": "Volver al Suite de Aplicaciones.",
    "tooltip.state.undo": "Deshacer.",
    "tooltip.state.redo": "Rehacer.",
    "tooltip.session.new": "Nueva sesión.",
    "tooltip.session.restore": "Restaurar sesión.",
    "tooltip.session.save": "Guardar sesión.",
    "base.app.title": "Demo (ES)",
    "Base.ErrorHeader": "Error",
    "Base.ErrorInfo.ErrorDescription.Generic": "Se ha producido un error inesperado",
    "errorPanel.label.timestamp": "Hora",
    "errorPanel.label.sessionId": "ID de sesión",
    "errorPanel.label.error": "Error",
    "errorPanel.label.serverCode": "Código de servidor",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copiar al portapapeles",
    "Base.ErrorPanel.Button.Undo": "Deshacer",
    "Base.AppTitle": "Suite de Aplicaciones",
    "tooltip.feature.help": "Ayuda",
    "tooltip.feature.settings": "Opciones",
    "tooltip.feature.toggle-workpiece-view": "Mostrar/Ocultar Pieza",
    "tooltip.feature.transfer-mesh": "Transferir Malla",
    "notifications.demo.title": "Ejemplos de notificaciones",
    "notifications.demo.info.button": "Mostrar notificación de información",
    "notifications.demo.success.button": "Mostrar notificación de éxito",
    "notifications.demo.warning.button": "Mostrar notificación de advertencia",
    "notifications.demo.error.button": "Mostrar notificación de error",
    "widgets.title": "Widgets",
    "footer.version.app": "app v{0}",
    "footer.version.grabcad": "GC",
    "footer.version.env": "({0})",
    "footer.version.components": "ASC v{0}",
    "footer.version.script": "script v{0}",
    "footer.version.trcad": "trCAD v{0}",
    "fileIO.import.subheading": "Importar {0}",
    "fileIO.import.subject": "Pieza de trabajo",
    "fileIO.import.hint": "Formato recomendado: .STL",
    "fileIO.import.sampleButton": "Probar datos de muestra",
    "fileIO.import.sampleTooltip": "Prueba la aplicación con datos de muestra: no se necesita ningún archivo",
    "fileIO.import.hintLinkDefault": "Haga clic aquí",
    "fileIO.export.heading": "Exportar",
    "fileIO.export.saveButton": "Guardar archivo",
    "fileIO.export.saveTooltip": "Guarde los modelos seleccionados en su ordenador.",
    "fileIO.export.transferButton": "Enviar a otras aplicaciones…",
    "fileIO.export.transferTooltip": "Envíe las piezas seleccionadas a otra aplicación de Additive App Suite para el siguiente paso.",
    "fileIO.export.scopeHeading": "Ámbito de exportación",
    "fileIO.export.scopeDescription": "Elija qué incluir en su exportación.",
    "fileIO.export.settingsHeading": "Ajustes para guardar archivo",
    "fileIO.export.nameLabel": "Nombre",
    "fileIO.export.nameTooltip": "Elija el nombre del paquete exportado.",
    "fileIO.export.formatLabel": "Formato del modelo",
    "fileIO.export.formatTooltip": "Elija el formato de archivo para guardar localmente.",
    "fileIO.export.ok": "Aceptar",
    "fileIO.export.scope.outputParts": "Piezas de salida",
    "fileIO.export.scope.workpieces": "Piezas de trabajo",
    "fileIO.export.scope.standardComponents": "Componentes estándar",
    "fileIO.export.auxHeading": "Archivos auxiliares",
    "fileIO.export.auxStep": "STEP",
    "fileIO.export.previewHeading": "Vista previa del diseño",
    "fileIO.export.previewDescription": "Obtenga una vista previa de su pieza final imprimible antes de exportar.",
    "fileIO.export.previewShow": "Mostrar vista previa de exportación",
    "fileIO.export.previewHide": "Ocultar vista previa de exportación",
    "fileIO.download.pending": "Descargando…",
    "fileIO.download.disabledTooltip": "Esta aplicación necesita una licencia para las descargas.",
    "notifications.configure.timeout": "Este proceso está tardando. ¿Desea cancelarlo y hacer ajustes?",
    "notifications.configure.timeout.cancel": "Cancelar",
    "notifications.configure.timeout.dismiss": "Descartar",
    "notifications.import.timeout": "Esta importación está tardando. ¿Desea cancelarla?",
    "fileIO.upload.chooseFile": "Elegir archivo",
    "fileIO.upload.dropHere": "o suelte el archivo aquí",
    "fileIO.upload.chooseImage": "Elegir imagen",
    "fileIO.upload.dropImageHere": "o suelte la imagen aquí",
    "fileIO.upload.accepts": "Acepta: {0}",
    "fileIO.upload.chooseNewFile": "Elegir nuevo archivo",
    "fileIO.upload.remove": "Eliminar",
    "fileIO.upload.replaceWarning": "Reemplazar este archivo no se puede deshacer. ¿Continuar?",
    "fileIO.upload.replaceConfirm": "Reemplazar",
    "fileIO.upload.replaceCancel": "Cancelar",
    "fileIO.upload.fileUploaded": "Archivo cargado",
    "fileIO.upload.filesUploadedCount": "{0} archivos cargados",
    "fileIO.upload.importing": "Importando archivo",
    "fileIO.upload.importingCount": "Importando archivo {0} de {1}",
    "paramWarning.notFound": "El parámetro «{0}» no se encuentra en el configurador",
    "tooltip.project.rename": "Renombrar",
    "tooltip.project.restore": "Restaurar estado guardado",
    "tooltip.project.save": "Guardar",
    "tooltip.project.delete": "Eliminar",
    "tooltip.project.open": "Abrir",
    "tooltip.state.undoWarn": "Deshacer borrará el historial de rehacer.",
    "modals.export.progress.heading": "Exportando…",
    "modals.export.progress.cancelButton": "Cancelar exportación",
    "modals.export.progress.cancelling": "Cancelando…",
    "modals.export.progress.finishing": "Finalizando…",
    "modals.export.progress.failedHeading": "Error de exportación",
    "modals.project.save.description": "Ponle un nombre a tu proyecto. También se usará como nombre de archivo al descargarlo.",
    "modals.grabcad.success.cancel": "Cancelar",
    "modals.grabcad.success.close": "Cerrar",
    "modals.grabcad.success.saveAndClose": "Guardar y cerrar",
    "notifications.project.new": "Proyecto nuevo creado",
    "notifications.project.loaded": "Proyecto cargado: {0}",
    "notifications.project.saved": "Proyecto guardado: {0}",
    "notifications.project.savedIncomplete": "Proyecto guardado: {0}, pero no se pudo capturar parte del estado de la aplicación",
    "notifications.project.loadFailed": "No se pudo cargar el archivo de proyecto",
    "notifications.project.wrongApp": "Este archivo .asproject es para la aplicación {0}.",
    "notifications.error.aborted": "Operación cancelada. Si usted no la canceló, su conexión puede ser inestable.",
    "notifications.api.badResponse": "Se produjo un error al comunicarse con el servidor. Inténtelo de nuevo.",
    "notifications.auth.signOut.error": "No se pudo cerrar la sesión. Inténtelo de nuevo.",
    "notifications.auth.terms.error": "No se pudo guardar su aceptación. Inténtelo de nuevo.",
    "notifications.export.noParts": "No hay piezas para exportar. Compruebe que el alcance de exportación esté configurado correctamente.",
    "notifications.import.failed": "Error al importar el archivo: {0}",
    "notifications.import.rejectedType.one": "{0} no es un tipo de archivo admitido.",
    "notifications.import.rejectedType.oneWithAccepts": "{0} no es un tipo de archivo admitido. Se admiten: {1}.",
    "notifications.import.rejectedType.many": "Estos archivos no son de un tipo admitido: {0}.",
    "notifications.import.rejectedType.manyWithAccepts": "Estos archivos no son de un tipo admitido: {0}. Se admiten: {1}.",
    "notifications.mesh.autoload.detected": "Malla detectada de {0}: {1}",
    "notifications.mesh.download.error": "Error al descargar la malla: {0}",
    "notifications.mesh.transfer.notReady": "No se puede transferir la malla: el configurador aún no está listo. Espere un momento e inténtelo de nuevo.",
    "notifications.mesh.transfer.no-apps.error": "No se puede transferir la malla: no hay aplicaciones disponibles. Puede que la configuración de la aplicación aún no se haya cargado.",
    "notifications.mesh.transfer.failed": "Error durante la transferencia de la malla: {0}",
    "notifications.mesh.transfer.save.error": "Error al guardar la malla",
    "notifications.mesh.rx.loadFailed": "No se pudo cargar la malla transferida: {0}",
    "notifications.mesh.rx.skip": "Omitir transferencia",
    "notifications.mesh.rx.saveAs": "Guardar la transferencia como archivo",
    "apps.general.may-lose-changes": "Tiene cambios sin guardar.",
    "apps.general.save-before-leaving": "¿Guardar su trabajo antes de salir?",
    "apps.general.saved-leave-when-ready": "Sus cambios se han guardado. Puede salir cuando quiera.",
    "apps.general.finishing-up": "Finalizando, espere...",
    "modals.unsaved.cancel": "Cancelar",
    "modals.unsaved.save": "Guardar",
    "modals.unsaved.proceed.close": "Cerrar",
    "modals.unsaved.proceed.home": "Salir",
    "modals.unsaved.proceed.new": "Empezar de nuevo",
    "modals.unsaved.proceed.transfer": "Transferir",
    "modals.unsaved.discard.close": "Cerrar sin guardar",
    "modals.unsaved.discard.home": "Salir sin guardar",
    "modals.unsaved.discard.new": "Empezar de nuevo sin guardar",
    "modals.unsaved.discard.transfer": "Transferir sin guardar",
    "modals.unsaved.saveAnd.close": "Guardar y cerrar",
    "modals.unsaved.saveAnd.home": "Guardar y salir",
    "modals.unsaved.saveAnd.new": "Guardar y empezar de nuevo",
    "modals.unsaved.saveAnd.transfer": "Guardar y transferir",
    "modals.project.save.title": "Guardar proyecto",
    "modals.project.save.name-label": "Nombre del proyecto",
    "modals.project.save.cancel": "Cancelar",
    "modals.project.save.confirm": "Guardar",
    "apps.general.restore-session.title": "Se encontró una sesión sin guardar",
    "apps.general.restore-session.body": "Tiene una sesión sin guardar de una visita anterior. ¿Desea restaurarla o empezar de nuevo?",
    "modals.restore-session.start-new": "Empezar de nuevo",
    "modals.restore-session.restore": "Restaurar",
    "apps.general.expired-session.title": "Sesión caducada",
    "apps.general.expired-session.body": "Su sesión ha caducado. Inicie una sesión nueva para continuar.",
    "modals.expired-session.start-new": "Iniciar sesión nueva",
    "apps.general.accept-terms.title": "Términos y condiciones",
    "apps.general.accept-terms.body": "Acepte los nuevos términos y condiciones para continuar.",
    "apps.general.accept-terms.link": "Términos y condiciones generales",
    "apps.general.accept-terms.checkbox": "He leído y acepto los términos anteriores.",
    "apps.general.accept-terms.cancel": "Cancelar",
    "apps.general.accept-terms.continue": "Continuar",
    "modals.paramate-error.ok": "Aceptar",
    "modals.paramate-error.session-id": "ID de sesión: {0}",
    "modals.clickthru.open-new-tab": "Abrir en una pestaña nueva",
    "modals.clickthru.close": "Cerrar",
    "modals.mobile-warning.title": "Dispositivo móvil detectado",
    "modals.mobile-warning.body": "¡Gracias por su interés en Additive App-Suite! Esta aplicación está optimizada para el escritorio; vuelva desde un dispositivo adecuado.",
    "modals.mobile-warning.back": "Volver a la tienda",
    "modals.transfer.ready.title": "Malla lista para transferir",
    "modals.transfer.ready.description": "Sus datos podrían perderse. Guarde su trabajo antes de continuar.",
    "modals.transfer.ready.action-label": "Transferir a:",
    "modals.transfer.ready.open-in-new-tab": "Abrir en una pestaña nueva",
    "header.help.tooltip": "¿Necesita ayuda? Haga clic aquí para ver el tutorial.",
    "license.label": "Licencia:",
    "license.none": "Sin licencia",
    "tooltip.feature.info": "Información",
    "footer.trinckle-label": "aplicación de automatización de diseño trinckle | Powered by paramate",
    "paramateError.serviceInterrupted.title": "Servicio interrumpido",
    "paramateError.serviceInterrupted.message": "Un servicio se interrumpió por una pérdida de conexión a internet. Compruebe su conexión e inténtelo de nuevo.",
    "paramateError.unsupportedFileFormat.title": "Formato de archivo no admitido",
    "paramateError.unsupportedFileFormat.message": "El formato del archivo subido no es compatible. Suba un archivo en un formato admitido.",
    "paramateError.fileTooComplex.title": "Archivo demasiado complejo",
    "paramateError.fileTooComplex.message": "El archivo subido parece demasiado complejo. Los archivos STEP y 3MF crecen mucho al convertirse y pueden superar el límite. Suprima la geometría que no necesite en su software CAD, exporte el archivo como STL y súbalo de nuevo. Se recomienda menos de 10 MB.",
    "paramateError.saveOperationTimeout.title": "Tiempo de guardado agotado",
    "paramateError.saveOperationTimeout.message": "No se pudo guardar el archivo. La operación superó el tiempo previsto. Si tiene activada la exportación STEP, cambiar a STL puede ayudar. Reducir el alcance de la exportación también acelera el proceso. Inténtelo de nuevo.",
    "paramateError.operationTimeout.title": "Tiempo de operación agotado",
    "paramateError.operationTimeout.message": "La operación en curso no se pudo completar. Superó el tiempo previsto.",
    "paramateError.unexpectedError.title": "Error inesperado",
    "paramateError.unexpectedError.message": "Se produjo un error inesperado en el servidor. Inténtelo de nuevo más tarde.",
    "paramateError.sessionFileNotRecognized.title": "Archivo de sesión no reconocido",
    "paramateError.sessionFileNotRecognized.message": "El archivo indicado no se pudo restaurar como sesión. Compruebe el archivo, puede que no sea compatible.",
    "paramateError.grabcadTransferFailed.title": "Transferencia fallida",
    "paramateError.grabcadTransferFailed.message": "No se pudo completar la transferencia a GrabCAD. Guarde su sesión e inténtelo más tarde. También puede exportar el archivo y subirlo a GrabCAD Print Pro manualmente.",
    "paramateError.meshTransferFailed.title": "Error al transferir la malla",
    "paramateError.meshTransferFailed.message": "No se pudo transferir la malla. El archivo puede ser demasiado grande, estar mal formado o no ser compatible con la aplicación de destino.",
    "userGreeting": "Hola {0}",
    "userGreeting.loading": "Hola",
    "signOutLink": "Cerrar sesión",
    "manageAccountLink": "Gestionar cuenta",
    "tooltip.userOptions": "Opciones de usuario",
    "license.expired": "{0} (caducada)",
    "license.trialDaysLeft": "{0} – quedan {1} días",
    "license.trialDayLeft": "{0} – queda {1} día",
    "license.type.trial": "Prueba",
    "license.type.pro": "Pro",
    "license.type.enterprise": "Enterprise",
    "user.unnamed": "Usuario",
    "session.untitled": "Sin título",
    "modals.error.prefix": "Error: {0}",
    "modals.mesh.history.title": "Historial de mallas",
    "modals.mesh.history.empty": "No se encontró historial de mallas",
    "modals.mesh.history.colName": "Nombre",
    "modals.mesh.history.colLastSave": "Último guardado",
    "modals.mesh.history.colOrigin": "Origen",
    "modals.mesh.history.clearAll": "Borrar todo el historial",
    "modals.mesh.history.close": "Cerrar",
    "modals.mesh.restore.title": "Restaurar malla",
    "modals.mesh.restore.body": "Se encontró una malla guardada anteriormente que se puede cargar:",
    "modals.mesh.restore.name": "Nombre:",
    "modals.mesh.restore.fromApp": "Desde la aplicación:",
    "modals.mesh.restore.lastSaved": "Último guardado:",
    "modals.mesh.restore.question": "¿Desea cargar esta malla?",
    "modals.mesh.restore.load": "Cargar malla",
    "modals.mesh.restore.skip": "Omitir",
    "modals.grabcad.success.transferred": "Su diseño se transfirió a GrabCAD Print y se colocó en la bandeja de impresión.",
    "modals.grabcad.success.prepare": "Puede iniciar la preparación de la impresión tras cerrar esta aplicación.",
    "modals.grabcad.success.saveFirst": "No olvide guardar su proyecto antes.",
    "modals.grabcad.success.saving": "Guardando…",
    "grabcad.transfer.button": "Transferir a GrabCAD Print",
    "grabcad.transfer.tooltip": "Transfiera su diseño a GrabCAD Print. Los modelos se colocarán en la bandeja de impresión, donde podrá prepararlos para imprimir. Nota: según su selección, puede alternar entre el conjunto y las piezas individuales en el árbol de modelos de GrabCAD Print.",
    "grabcad.transfer.sending": "Enviando...",
    "fileIO.import.trySample": "Probar datos de ejemplo",
    "modals.clickthru.noUrl": "No se indicó ninguna URL para la demostración"
  },
  "fr": {
    "helpTitle": "Aide",
    "helpText": "Ce texte est utilisé pour fournir de l'aide au utilisateur.",
    "langSelector": "Sélectionner la langue",
    "test": "Bonjour le monde",
    "welcomeMsg":"Bienvenue dans l'application de démonstration de Trinkle WebComponents.",
    "param.blueness": "Bleu",
    "apps.general.exit-without-saving": "Vous êtes sur le point de quitter avec des modifications non enregistrées. Votre progression sera perdue. Voulez-vous continuer?",
    "tooltip.view.perspective": "Basculer la vue en perspective.",
    "tooltip.view.fit": "Ajuster à l'écran.",
    "tooltip.view.iso": "Vue isométrique.",
    "tooltip.view.front": "Basculer la vue avant/arrière.",
    "tooltip.view.right": "Basculer la vue droite/gauche.",
    "tooltip.view.top": "Basculer la vue supérieure/inférieure.",
    "tooltip.apps.home": "Retour à la Suite d'Applications.",
    "tooltip.state.undo": "Annuler.",
    "tooltip.state.redo": "Rétablir.",
    "tooltip.session.new": "Nouvelle session.",
    "tooltip.session.restore": "Restaurer la session.",
    "tooltip.session.save": "Enregistrer la session.",
    "base.app.title": "Demo (FR)",
    "Base.ErrorHeader": "Erreur",
    "Base.ErrorInfo.ErrorDescription.Generic": "Une erreur inattendue s'est produite",
    "errorPanel.label.timestamp": "Horodatage",
    "errorPanel.label.sessionId": "ID de session",
    "errorPanel.label.error": "Erreur",
    "errorPanel.label.serverCode": "Code serveur",
    "Base.ErrorPanel.Button.CopyToClipboard": "Copier dans le presse-papiers",
    "Base.ErrorPanel.Button.Undo": "Annuler",
    "Base.AppTitle": "Suite d'Applications",
    "tooltip.feature.help": "Aide",
    "tooltip.feature.settings": "Options",
    "tooltip.feature.toggle-workpiece-view": "Afficher/Masquer la pièce",
    "tooltip.feature.transfer-mesh": "Transférer le maillage",
    "notifications.demo.title": "Exemples de notifications",
    "notifications.demo.info.button": "Afficher la notification d'information",
    "notifications.demo.success.button": "Afficher la notification de succès",
    "notifications.demo.warning.button": "Afficher la notification de préavis",
    "notifications.demo.error.button": "Afficher la notification d'erreur",
    "notifications.demo.persistent.button": "Afficher la notification persistante",
    "notifications.demo.timeout.button": "Timeout (10s)",
    "notifications.demo.trigger-error.button": "Afficher la notification d'erreur",
    "notifications.demo.clear.button": "Effacer toutes les notifications",
    "notifications.demo.info.message": "Cette notification est une notification d'information",
    "notifications.demo.success.message": "Cette notification est une notification de succès",
    "notifications.demo.warning.message": "Cette notification est une notification de préavis",
    "notifications.demo.error.message": "Cette notification est une notification d'erreur",
    "notifications.demo.persistent.message": "Cette notification est une notification persistante",
    "notifications.demo.timeout.message": "Cette notification est une notification de timeout",
    "notifications.mesh.transfer.save.success": "Métier sauvegardé avec succès",
    "notifications.mesh.transfer.save.error": "Erreur lors de la sauvegarde du métier",
    "notifications.mesh.autoload.detected": "Maillage détecté depuis {0} : {1}",
    "translations.demo": "Ce texte sera traduit automatiquement.",
    "widgets.title": "Widgets",
    "footer.version.app": "app v{0}",
    "footer.version.grabcad": "GC",
    "footer.version.env": "({0})",
    "footer.version.components": "ASC v{0}",
    "footer.version.script": "script v{0}",
    "footer.version.trcad": "trCAD v{0}",
    "fileIO.import.subheading": "Importer {0}",
    "fileIO.import.subject": "Pièce",
    "fileIO.import.hint": "Format recommandé : .STL",
    "fileIO.import.sampleButton": "Essayer des données d'exemple",
    "fileIO.import.sampleTooltip": "Essayez l'application avec des données d'exemple - aucun fichier requis",
    "fileIO.import.hintLinkDefault": "Cliquez ici",
    "fileIO.export.heading": "Exporter",
    "fileIO.export.saveButton": "Enregistrer le fichier",
    "fileIO.export.saveTooltip": "Enregistrez les modèles sélectionnés sur votre ordinateur.",
    "fileIO.export.transferButton": "Envoyer vers d'autres applications…",
    "fileIO.export.transferTooltip": "Envoyez les pièces sélectionnées vers une autre application d'Additive App Suite pour l'étape suivante.",
    "fileIO.export.scopeHeading": "Portée de l'export",
    "fileIO.export.scopeDescription": "Choisissez ce qui doit être inclus dans votre export.",
    "fileIO.export.settingsHeading": "Paramètres d'enregistrement du fichier",
    "fileIO.export.nameLabel": "Nom",
    "fileIO.export.nameTooltip": "Choisissez le nom du package exporté.",
    "fileIO.export.formatLabel": "Format du modèle",
    "fileIO.export.formatTooltip": "Choisissez le format de fichier pour l'enregistrement local.",
    "fileIO.export.ok": "OK",
    "fileIO.export.scope.outputParts": "Pièces de sortie",
    "fileIO.export.scope.workpieces": "Pièces à usiner",
    "fileIO.export.scope.standardComponents": "Composants standard",
    "fileIO.export.auxHeading": "Fichiers auxiliaires",
    "fileIO.export.auxStep": "STEP",
    "fileIO.export.previewHeading": "Aperçu du design",
    "fileIO.export.previewDescription": "Prévisualisez votre pièce finale imprimable avant l'export.",
    "fileIO.export.previewShow": "Afficher l'aperçu de l'export",
    "fileIO.export.previewHide": "Masquer l'aperçu de l'export",
    "fileIO.download.pending": "Téléchargement…",
    "fileIO.download.disabledTooltip": "Cette application nécessite une licence pour les téléchargements.",
    "notifications.configure.timeout": "Ce traitement prend du temps. Souhaitez-vous l'annuler et ajuster ?",
    "notifications.configure.timeout.cancel": "Annuler",
    "notifications.configure.timeout.dismiss": "Ignorer",
    "notifications.import.timeout": "Cet import prend du temps. Souhaitez-vous l'annuler ?",
    "fileIO.upload.chooseFile": "Choisir un fichier",
    "fileIO.upload.dropHere": "ou déposez le fichier ici",
    "fileIO.upload.chooseImage": "Choisir une image",
    "fileIO.upload.dropImageHere": "ou déposez l'image ici",
    "fileIO.upload.accepts": "Accepte : {0}",
    "fileIO.upload.chooseNewFile": "Choisir un nouveau fichier",
    "fileIO.upload.remove": "Supprimer",
    "fileIO.upload.replaceWarning": "Le remplacement de ce fichier est irréversible. Continuer ?",
    "fileIO.upload.replaceConfirm": "Remplacer",
    "fileIO.upload.replaceCancel": "Annuler",
    "fileIO.upload.fileUploaded": "Fichier téléchargé",
    "fileIO.upload.filesUploadedCount": "{0} fichiers téléchargés",
    "fileIO.upload.importing": "Importation du fichier",
    "fileIO.upload.importingCount": "Importation du fichier {0} sur {1}",
    "paramWarning.notFound": "Le paramètre « {0} » est introuvable dans le configurateur",
    "tooltip.project.rename": "Renommer",
    "tooltip.project.restore": "Restaurer l'état enregistré",
    "tooltip.project.save": "Enregistrer",
    "tooltip.project.delete": "Supprimer",
    "tooltip.project.open": "Ouvrir",
    "tooltip.state.undoWarn": "Annuler effacera l'historique de rétablissement !",
    "modals.export.progress.heading": "Exportation…",
    "modals.export.progress.cancelButton": "Annuler l'export",
    "modals.export.progress.cancelling": "Annulation…",
    "modals.export.progress.finishing": "Finalisation…",
    "modals.export.progress.failedHeading": "Échec de l'export",
    "modals.project.save.description": "Donnez un nom à votre projet. Il sera également utilisé comme nom de fichier lors du téléchargement.",
    "modals.grabcad.success.cancel": "Annuler",
    "modals.grabcad.success.close": "Fermer",
    "modals.grabcad.success.saveAndClose": "Enregistrer et fermer",
    "notifications.project.new": "Nouveau projet créé",
    "notifications.project.loaded": "Projet chargé : {0}",
    "notifications.project.saved": "Projet enregistré : {0}",
    "notifications.project.savedIncomplete": "Projet enregistré : {0}, mais une partie de l’état de l’application n’a pas pu être capturée",
    "notifications.project.loadFailed": "Impossible de charger le fichier de projet",
    "notifications.project.wrongApp": "Ce fichier .asproject est destiné à l’application {0}.",
    "notifications.error.aborted": "Opération interrompue. Si vous ne l’avez pas annulée, votre connexion est peut-être instable.",
    "notifications.api.badResponse": "Une erreur est survenue lors de la communication avec le serveur. Veuillez réessayer.",
    "notifications.auth.signOut.error": "La déconnexion a échoué. Veuillez réessayer.",
    "notifications.auth.terms.error": "Votre acceptation n’a pas pu être enregistrée. Veuillez réessayer.",
    "notifications.export.noParts": "Aucune pièce à exporter. Vérifiez que la portée de l’export est correctement configurée.",
    "notifications.import.failed": "Échec de l’import du fichier : {0}",
    "notifications.import.rejectedType.one": "{0} n’est pas un type de fichier accepté.",
    "notifications.import.rejectedType.oneWithAccepts": "{0} n’est pas un type de fichier accepté. Types acceptés : {1}.",
    "notifications.import.rejectedType.many": "Ces fichiers ne sont pas d’un type accepté : {0}.",
    "notifications.import.rejectedType.manyWithAccepts": "Ces fichiers ne sont pas d’un type accepté : {0}. Types acceptés : {1}.",
    "notifications.mesh.download.error": "Erreur lors du téléchargement du maillage : {0}",
    "notifications.mesh.transfer.notReady": "Impossible de transférer le maillage : le configurateur n’est pas encore prêt. Patientez un instant et réessayez.",
    "notifications.mesh.transfer.no-apps.error": "Impossible de transférer le maillage : aucune application n’est disponible. La configuration de l’application n’est peut-être pas encore chargée.",
    "notifications.mesh.transfer.failed": "Erreur pendant le transfert du maillage : {0}",
    "notifications.mesh.rx.loadFailed": "Impossible de charger le maillage transféré : {0}",
    "notifications.mesh.rx.skip": "Ignorer le transfert",
    "notifications.mesh.rx.saveAs": "Enregistrer le transfert dans un fichier",
    "apps.general.may-lose-changes": "Vous avez des modifications non enregistrées.",
    "apps.general.save-before-leaving": "Enregistrer votre travail avant de quitter ?",
    "apps.general.saved-leave-when-ready": "Vos modifications ont été enregistrées. Vous pouvez quitter quand vous le souhaitez.",
    "apps.general.finishing-up": "Finalisation, veuillez patienter...",
    "modals.unsaved.cancel": "Annuler",
    "modals.unsaved.save": "Enregistrer",
    "modals.unsaved.proceed.close": "Fermer",
    "modals.unsaved.proceed.home": "Quitter",
    "modals.unsaved.proceed.new": "Recommencer",
    "modals.unsaved.proceed.transfer": "Transférer",
    "modals.unsaved.discard.close": "Fermer sans enregistrer",
    "modals.unsaved.discard.home": "Quitter sans enregistrer",
    "modals.unsaved.discard.new": "Recommencer sans enregistrer",
    "modals.unsaved.discard.transfer": "Transférer sans enregistrer",
    "modals.unsaved.saveAnd.close": "Enregistrer et fermer",
    "modals.unsaved.saveAnd.home": "Enregistrer et quitter",
    "modals.unsaved.saveAnd.new": "Enregistrer et recommencer",
    "modals.unsaved.saveAnd.transfer": "Enregistrer et transférer",
    "modals.project.save.title": "Enregistrer le projet",
    "modals.project.save.name-label": "Nom du projet",
    "modals.project.save.cancel": "Annuler",
    "modals.project.save.confirm": "Enregistrer",
    "apps.general.restore-session.title": "Session non enregistrée trouvée",
    "apps.general.restore-session.body": "Une session non enregistrée d’une visite précédente est disponible. Voulez-vous la restaurer ou recommencer ?",
    "modals.restore-session.start-new": "Recommencer",
    "modals.restore-session.restore": "Restaurer",
    "apps.general.expired-session.title": "Session expirée",
    "apps.general.expired-session.body": "Votre session a expiré. Démarrez une nouvelle session pour continuer.",
    "modals.expired-session.start-new": "Démarrer une nouvelle session",
    "apps.general.accept-terms.title": "Conditions générales",
    "apps.general.accept-terms.body": "Veuillez accepter les nouvelles conditions générales pour continuer.",
    "apps.general.accept-terms.link": "Conditions générales de vente",
    "apps.general.accept-terms.checkbox": "J’ai lu et j’accepte les conditions ci-dessus.",
    "apps.general.accept-terms.cancel": "Annuler",
    "apps.general.accept-terms.continue": "Continuer",
    "modals.paramate-error.ok": "OK",
    "modals.paramate-error.session-id": "ID de session : {0}",
    "modals.clickthru.open-new-tab": "Ouvrir dans un nouvel onglet",
    "modals.clickthru.close": "Fermer",
    "modals.mobile-warning.title": "Appareil mobile détecté",
    "modals.mobile-warning.body": "Merci de votre intérêt pour Additive App-Suite ! Cette application est optimisée pour le bureau, revenez depuis un appareil adapté.",
    "modals.mobile-warning.back": "Retour à la boutique",
    "modals.transfer.ready.title": "Maillage prêt à être transféré",
    "modals.transfer.ready.description": "Vos données risquent d’être perdues. Enregistrez votre travail avant de continuer.",
    "modals.transfer.ready.action-label": "Transférer vers :",
    "modals.transfer.ready.open-in-new-tab": "Ouvrir dans un nouvel onglet",
    "header.help.tooltip": "Besoin d’aide ? Cliquez ici pour le tutoriel.",
    "license.label": "Licence :",
    "license.none": "Aucune licence",
    "tooltip.feature.info": "Informations",
    "footer.trinckle-label": "application d’automatisation de conception trinckle | Powered by paramate",
    "paramateError.serviceInterrupted.title": "Service interrompu",
    "paramateError.serviceInterrupted.message": "Un service a été interrompu par une perte de connexion internet. Vérifiez votre connexion et réessayez.",
    "paramateError.unsupportedFileFormat.title": "Format de fichier non pris en charge",
    "paramateError.unsupportedFileFormat.message": "Le format du fichier envoyé n’est pas pris en charge. Envoyez un fichier dans un format accepté.",
    "paramateError.fileTooComplex.title": "Fichier trop complexe",
    "paramateError.fileTooComplex.message": "Le fichier envoyé semble trop complexe. Les fichiers STEP et 3MF grossissent beaucoup à la conversion et peuvent dépasser la limite. Supprimez la géométrie inutile dans votre logiciel CAO, exportez le fichier en STL et renvoyez-le. Moins de 10 Mo est recommandé.",
    "paramateError.saveOperationTimeout.title": "Délai d’enregistrement dépassé",
    "paramateError.saveOperationTimeout.message": "Le fichier n’a pas pu être enregistré. L’opération a dépassé le délai prévu. Si l’export STEP est activé, passer au STL peut aider. Réduire la portée de l’export accélère aussi le traitement. Veuillez réessayer.",
    "paramateError.operationTimeout.title": "Délai d’opération dépassé",
    "paramateError.operationTimeout.message": "L’opération en cours n’a pas pu aboutir. Elle a dépassé le délai prévu.",
    "paramateError.unexpectedError.title": "Erreur inattendue",
    "paramateError.unexpectedError.message": "Une erreur inattendue est survenue sur le serveur. Veuillez réessayer plus tard.",
    "paramateError.sessionFileNotRecognized.title": "Fichier de session non reconnu",
    "paramateError.sessionFileNotRecognized.message": "Le fichier fourni n’a pas pu être restauré comme session. Vérifiez le fichier, il est peut-être incompatible.",
    "paramateError.grabcadTransferFailed.title": "Échec du transfert",
    "paramateError.grabcadTransferFailed.message": "Le transfert vers GrabCAD n’a pas pu aboutir. Enregistrez votre session et réessayez plus tard. Vous pouvez aussi exporter le fichier et l’envoyer vous-même dans GrabCAD Print Pro.",
    "paramateError.meshTransferFailed.title": "Échec du transfert du maillage",
    "paramateError.meshTransferFailed.message": "Le maillage n’a pas pu être transféré. Le fichier est peut-être trop volumineux, mal formé ou incompatible avec l’application cible.",
    "userGreeting": "Bonjour {0}",
    "userGreeting.loading": "Bonjour",
    "signOutLink": "Se déconnecter",
    "manageAccountLink": "Gérer le compte",
    "tooltip.userOptions": "Options utilisateur",
    "license.expired": "{0} (expirée)",
    "license.trialDaysLeft": "{0} – {1} jours restants",
    "license.trialDayLeft": "{0} – {1} jour restant",
    "license.type.trial": "Essai",
    "license.type.pro": "Pro",
    "license.type.enterprise": "Enterprise",
    "user.unnamed": "Utilisateur",
    "session.untitled": "Sans titre",
    "modals.error.prefix": "Erreur : {0}",
    "modals.mesh.history.title": "Historique des maillages",
    "modals.mesh.history.empty": "Aucun historique de maillage",
    "modals.mesh.history.colName": "Nom",
    "modals.mesh.history.colLastSave": "Dernier enregistrement",
    "modals.mesh.history.colOrigin": "Origine",
    "modals.mesh.history.clearAll": "Effacer tout l’historique",
    "modals.mesh.history.close": "Fermer",
    "modals.mesh.restore.title": "Restaurer le maillage",
    "modals.mesh.restore.body": "Un maillage enregistré précédemment a été trouvé et peut être chargé :",
    "modals.mesh.restore.name": "Nom :",
    "modals.mesh.restore.fromApp": "Depuis l’application :",
    "modals.mesh.restore.lastSaved": "Dernier enregistrement :",
    "modals.mesh.restore.question": "Voulez-vous charger ce maillage ?",
    "modals.mesh.restore.load": "Charger le maillage",
    "modals.mesh.restore.skip": "Ignorer",
    "modals.grabcad.success.transferred": "Votre conception a été transférée vers GrabCAD Print et placée sur le plateau.",
    "modals.grabcad.success.prepare": "Vous pouvez lancer la préparation de l’impression après avoir fermé cette application.",
    "modals.grabcad.success.saveFirst": "N’oubliez pas d’enregistrer votre projet au préalable.",
    "modals.grabcad.success.saving": "Enregistrement…",
    "grabcad.transfer.button": "Transférer vers GrabCAD Print",
    "grabcad.transfer.tooltip": "Transférez votre conception vers GrabCAD Print. Les modèles seront placés sur le plateau, où vous pourrez les préparer pour l’impression. Remarque : selon votre sélection, vous pouvez basculer entre l’assemblage et les pièces individuelles dans l’arborescence de GrabCAD Print.",
    "grabcad.transfer.sending": "Envoi en cours...",
    "fileIO.import.trySample": "Essayer des données d’exemple",
    "modals.clickthru.noUrl": "Aucune URL fournie pour la démonstration"
  }
}
